<template>
  <div class="actions-collapsed-list">
    <button
      class="btn btn-function exit-collapsed-list"
      @click="collapseActions"
    >
      <i
        v-tooltip.right.hover="$t('CANCEL')"
        class="glyphicon glyphicon-chevron-left"
        aria-hidden="true"
      />
    </button>

    <div v-if="createAccess" class="action-icon">
      <a class="btn btn-list-function" @click="showForm" :href="href">
        <i
          v-tooltip.right.hover="$t('BUYERS_ACTIONS_EDIT')"
          class="typcn typcn-edit"
          aria-hidden="true"
        />
        <span v-t="'BUYERS_ACTIONS_EDIT'" class="hint-text-mobile" />
      </a>
    </div>

    <div class="action-icon">
      <button
        @click="showInvites"
        :disabled="disabled"
        class="btn btn-list-function"
      >
        <i
          class="fa m-t-4 fa-user-plus"
          v-tooltip.right.hover="$t('MANAGE_USER_INVITES')"
          aria-hidden="true"
        ></i>
        <span class="hint-text-mobile" v-t="'MANAGE_USER_INVITES'"> </span>
      </button>
    </div>

    <div v-if="isAdmin" class="action-icon">
      <button
        class="btn btn-list-function"
        @click="resetCapCounters"
        :disabled="disabled"
      >
        <i
          v-tooltip.left.hover="$t('RESET_CAP_COUNTERS')"
          class="typcn typcn-arrow-loop"
        >
        </i>

        <span class="hint-text-mobile" v-t="'RESET_CAP_COUNTERS'"> </span>
      </button>
    </div>

    <div v-if="isAdmin" class="action-icon m-l-3">
      <button
        class="btn btn-list-function"
        @click="showReferences"
        :disabled="disabled"
      >
        <i
          class="typcn typcn-flow-children"
          v-tooltip.left.hover="$t('BUYER_ACTIONS_SHOW_REFERENCES')"
          aria-hidden="true"
        />
        <span class="hint-text-mobile" v-t="'BUYER_ACTIONS_SHOW_REFERENCES'" />
      </button>
    </div>

    <div class="action-icon">
      <button
        @click="confirmDelete"
        :disabled="disabled"
        class="btn btn-list-function"
      >
        <i
          class="typcn typcn-trash"
          v-tooltip.right.hover="$t('BUYERS_DELETE')"
          aria-hidden="true"
        ></i>
        <span class="hint-text-mobile" v-t="'BUYERS_DELETE'"> </span>
      </button>
    </div>
    <ChangeLogObjectButtonAction
      :is-disabled="disabled"
      :object-id="currentBuyer.id"
      :object-name="currentBuyer.name"
      object-type="buyer"
    />
  </div>
</template>

<script>
import ChangeLogObjectButtonAction from '@/core/components/ChangeLog/ChangeLogObjectButtonAction';
import messages from '../locales';
import sharedMessages from '@/core/locales';
import { accountsService } from '@/angularBridgeCode/ringbaPortal.servicesModule';

export default {
  name: 'BuyerActions',
  components: {
    ChangeLogObjectButtonAction,
  },
  props: {
    createAccess: {
      type: Boolean,
      default: false,
    },
    currentBuyer: {
      type: Object,
      default() {
        return {};
      },
    },
    isAdmin: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    href: {
      type: String,
      default: '',
    },
  },
  computed: {
    currentUserName() {
      return accountsService.currentUserName;
    },
  },
  methods: {
    confirmDelete() {
      if (!this.disabled) {
        this.$emit('confirm-delete', this.currentBuyer);
      }
    },
    showForm(e) {
      e.preventDefault();

      this.$emit('show-edit-form', this.currentBuyer);
    },
    showInvites() {
      if (this.disabledInvites) {
        return;
      }
      this.$emit('show-invites', this.currentBuyer);
    },
    resetCapCounters() {
      this.$emit('confirm-reset-cap-counters', this.currentBuyer);
    },
    showReferences() {
      if (!this.disabled) {
        this.$emit('show-references', this.currentBuyer);
      }
    },
    collapseActions() {
      this.$emit('collapse-actions', this.currentBuyer);
    },
  },
  i18n: {
    messages,
    sharedMessages,
    locale: 'en',
  },
};
</script>

<style lang="scss">
</style>
